import React from 'react';
import { Route, Switch } from 'react-router-dom';
import MyUtil from '../../functions/MyUtil';
import '../css/Warehouse.css';
import FormAddCar from './FormAddCar';
import FormAddMotorbike from './FormAddMotorbike';
import ListVehicle from './ListVehicle';

const Warehouse = (props) => {
  return (
    <div>
      <Switch>
        {MyUtil.hasPermission(props.match.url, 'view') && (
          <Route
            exact
            path={`${props.match.url}`}
            component={() => <ListVehicle match_parent={props.match} />}
          />
        )}
        {MyUtil.hasPermission(props.match.url, 'add') && (
          <Route path={`${props.match.url}/add-car`} component={FormAddCar} />
        )}
        {MyUtil.hasPermission(props.match.url, 'add') && (
          <Route
            path={`${props.match.url}/add-motorbike`}
            component={FormAddMotorbike}
          />
        )}
        {MyUtil.hasPermission(props.match.url, 'update') && (
          <Route
            path={`${props.match.url}/edit-car-depot/:vhc_id`}
            component={FormAddCar}
          />
        )}
        {MyUtil.hasPermission(props.match.url, 'update') && (
          <Route
            path={`${props.match.url}/edit-motorbike-depot/:vhc_id`}
            component={FormAddMotorbike}
          />
        )}
      </Switch>
    </div>
  );
};

export default Warehouse;
